import { Box } from '@chakra-ui/react'

export default function () {
  return <Box />
}
